import { gql } from '@apollo/client';

export type CreateFavouriteSupplierVariables = {
  supplierId: string;
};

export type CreateFavouriteSupplierResponse = {
  createFavouriteSupplier: boolean | null;
};

export const CREATE_FAVOURITE_SUPPLIER = gql`
  mutation createFavouriteSupplier($supplierId: String!) {
    createFavouriteSupplier(supplierId: $supplierId)
  }
`;
